export default "__VITE_ASSET__BvIGyMd$__"